import { authRoles } from 'app/auth';
import { Roles } from 'constant/user';

export const isAdmin = (role: Roles) => authRoles.admin.includes(role);

export const isStaff = (role: Roles) => authRoles.staff.includes(role);

export const isUser = (role: Roles) => authRoles.user.includes(role);
